import React, { useEffect, useState } from "react";
import CommonFormBuilder from "../../CommonComponenets/FormBuilder";
import BeckerWorkAdjustmentProfile from "../components/beckerwork";
import PatientCard from "../../../shared/cards/PatientCard";
import BergBalanceScale from "../../OT/components/BBS";
import MoCAAssessment from '../../OT/components/MocA';
import BTEAssessment from "./BTSPrimus";
// export const VOCATIONAL_REHAB_REGISTRY = {
//   BeckerWorkAdjustmentProfile,
//   BergBalanceScale,
//   MoCAAssessment,
//   BTEAssessment,
// };
export const VOCATIONAL_REHAB_REGISTRY = {
  BeckerWorkAdjustmentProfile,
  BergBalanceScale,
  MoCAAssessment,
  BTEAssessment,
};

export const TRAINER_OPTIONS = [
  { label: "Khairunnisa Mokhtar", value: "khairunnisa_mokhtar" },
  { label: "Muzammer Zakaria", value: "muzammer_zakaria" },
  { label: "Mohd Rafidy A. Bakar", value: "mohd_rafidy_a_bakar" },
  { label: "Muhamad Zharif Zainal", value: "muhamad_zharif_zainal" },
  { label: "Muhammad Syafiq Arshad", value: "muhammad_syafiq_arshad" },
  { label: "Sabaruddin Mohammad", value: "sabaruddin_mohammad" },
  { label: "Muhammad Luqmanul Hakiim Zaidi", value: "muhammad_luqmanul_hakiim_zaidi" },
  { label: "Azzratul Auri Azir", value: "azzratul_auri_azir" },
  { label: "Muhammad 'Irfan Azman", value: "muhammad_irfan_azman" },
  { label: "Mohd Zaki Ali", value: "mohd_zaki_ali" },
  { label: "Irma Shuhada Jhorni", value: "irma_shuhada_jhorni" },
  { label: "Muhammad Saiful Darus", value: "muhammad_saiful_darus" },
  { label: "All Trainers", value: "all_trainers" }
];
export const MODULE_OPTIONS = [
  { label: "3D Innovation", value: "3d_innovation" },
  { label: "Art & Crafts", value: "art_crafts" },
  { label: "Automotive Technology", value: "automotive_technology" },
  { label: "Bakery", value: "bakery" },
  { label: "Barista", value: "barista" },
  { label: "Call Centre", value: "call_centre" },
  { label: "Carpentry", value: "carpentry" },
  { label: "Creative Multimedia", value: "creative_multimedia" },
  { label: "Culinary", value: "culinary" },
  { label: "Design & Printing", value: "design_printing" },
  { label: "Domestic Electrical", value: "domestic_electrical" },
  { label: "Electrical", value: "electrical" },
  { label: "Electric Vehicle (EV)", value: "electric_vehicle_ev" },
  { label: "Electronics", value: "electronics" },
  { label: "Entrepreneurship", value: "entrepreneurship" },
  { label: "Floristry", value: "floristry" },
  { label: "Graphic & Virtual Arts", value: "graphic_virtual_arts" },
  { label: "Hairstyling", value: "hairstyling" },
  { label: "Job Profiling & Readiness", value: "job_profiling_readiness" },
  { label: "Office Administration", value: "office_administration" },
  { label: "Sewing & Fashion", value: "sewing_fashion" },
  { label: "Spa & Cosmetology", value: "spa_cosmetology" },
  { label: "Urban Farming", value: "urban_farming" },
  { label: "Work Trial", value: "work_trial" }
];

// export const MODULE_OPTIONS = [
//   { label: "Sewing", value: "sewing" },
//   { label: "Entrepreneurship", value: "entrepreneurship" },
//   { label: "Electric / Electronic", value: "electric_electronic" },
//   { label: "Hairstyling", value: "hairstyling" },
//   { label: "Design", value: "design" },
//   { label: "Office Administration", value: "office_administration" },
//   { label: "Bakery", value: "bakery" },
//   { label: "Culinary", value: "culinary" },
//   { label: "Barista", value: "barista" },
//   { label: "Florist", value: "florist" },
//   { label: "Urban Farming", value: "urban_farming" },
//   { label: "Pre-Vocational", value: "pre_vocational" },
//   { label: "Initial / Screening Assessment", value: "initial_screening_assessment" }
// ];

/* ===================== OPTIONS ===================== */

const YES_NO = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" }
];
const Static_Dynamic = [
  { label: "Static", value: "static" },
  { label: "Dynamic", value: "dynamic" }
];
const Functional_assessment = [
  { label: "Independent", value: "independent" },
  { label: "Supervision", value: "supervision" },
  { label: "Minimal Assistance", value: "mia" },
  { label: "Moderate Assistance", value: "moa" },
  { label: "Maximal Assistance", value: "maa" },
  { label: "Dependent", value: "dependent" },
  { label: "Not Assessed / NotApplicable", value: "NA" },

];
const DEMAND_RATING_OPTIONS = [
  { label: "0 - Unable/Full Assistance", value: 0 },
  { label: "1 - Significant Difficulty", value: 1 },
  { label: "2 - Moderate Difficulty", value: 2 },
  { label: "3 - Mild Difficulty", value: 3 },
  { label: "4 - Independent/Functional", value: 4 }
];
const PROGNOSIS_OPTIONS = [
  { label: "Excellent", value: "excellent" },
  { label: "Good", value: "good" },
  { label: "Fair", value: "fair" },
  { label: "Poor", value: "poor" }
];

const AMBULATORY_OPTIONS = [
  { label: "Independent walking", value: "independent" },
  { label: "Wheelchair", value: "wheelchair" },
  { label: "Quadripod narrowbase", value: "Quadripodnarrowbase" },
  { label: "Quadripod wide base", value: "Quadripodwidebase" },
  { label: "Walking stick", value: "stick" },
  { label: "Walking frame", value: "frame" },
  { label: "Elbow crutches", value: "crutches" },
  { label: "Others", value: "others" }
];

export default function OccupationalRehab({ patient, onUpdatePatient, onSubmit, onBack,onValuesChange }) {
  const [values, setValues] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState("subjective");

  /* --------- Patient History State --------- */
 

  /* ---------------- STORAGE ---------------- */
  const storageKey = patient
    ? `work_assessment_draft_${patient.id}`
    : null;

  useEffect(() => {
    if (!storageKey) return;
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      setValues(JSON.parse(saved).values || {});
    }
  }, [storageKey]);

  useEffect(() => {
    if (!patient) return;

    setValues(v => ({
      ...v,
      pmh_from_registration:
        patient.medical_history || "No data available",

      family_social_from_registration:
        patient.diagnosis_history || "No data available"
    }));
  }, [patient]);

  /* --------- Keep patient history in sync --------- */
  // useEffect(() => {
  //   setPatientHistory({
  //     past_medical_history: patient?.medical_history || "",
  //     past_family_history: patient?.family_medical_history || "",
  //     alerts_and_allergies: patient?.alerts_and_allergies_history || "",
  //   });
  // }, [patient?.id]);

  /* --------- Persist patient history changes --------- */
  // useEffect(() => {
  //   if (!patient?.id) return;
  //   const updated = {
  //     ...patient,
  //     medical_history: patientHistory.past_medical_history,
  //     family_medical_history: patientHistory.past_family_history,
  //     alerts_and_allergies_history: patientHistory.alerts_and_allergies,
  //   };
  //   localStorage.setItem("patient_" + patient.id, JSON.stringify(updated));
  //   onUpdatePatient?.(updated);
  // }, [patient?.id, patientHistory.past_medical_history, patientHistory.past_family_history, patientHistory.alerts_and_allergies]);

  // const onChange = (name, value) => {
  //   setValues(v => ({ ...v, [name]: value }));
  // };
const onChange = (name, value) => {
  setValues(v => {
    const updated = {
      ...v,
      [name]: value
    };

    onValuesChange?.(updated);

    return updated;
  });
};
  const handleAction = (type) => {
    if (type === "back") onBack?.();
    if (type === "clear") {
      setValues({});
      setSubmitted(false);
      localStorage.removeItem(storageKey);
    }
    if (type === "save") {
      localStorage.setItem(
        storageKey,
        JSON.stringify({ values, updatedAt: new Date() })
      );
      alert("draft saved");
    }
  };

  const handleSubmit = () => {
    setSubmitted(true);
    onSubmit?.(values);
    alert("assessment submitted");
  };

  const today = new Date();
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      return new Date(dateStr).toLocaleDateString();
    } catch {
      return "-";
    }
  };
  const calculateDuration = (onset) => {
    if (!onset) return "-";
    const onsetDate = new Date(onset);
    const diffMs = today - onsetDate;
    if (Number.isNaN(diffMs) || diffMs < 0) return "-";
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);
    if (years > 0) return `${years} yr ${months % 12} mo`;
    if (months > 0) return `${months} mo`;
    return `${days} days`;
  };

const SUBJECTIVE_SCHEMA = {
  title: "",
   actions: [
      { type: "back", label: "Back" },
      { type: "clear", label: "Clear" },
      { type: "save", label: "Save" }
    ],
  sections: [
    {
      fields: [
          { name: "History of Present", label: "History of Present Illnes", type: "input" },
        { type: "subheading", label: "Educational Background" },
          {
          name: "highest_education_level",
          // label: "Highest Education Level",
          type: "checkbox-group",
          options: [
            { label: "PhD Degree", value: "phd_degree" },
            { label: "Master Degree", value: "master_degree" },
            { label: "Bachelor Degree", value: "bachelor_degree" },
            { label: "Professional Certificate", value: "professional_certificate" },
            { label: "Diploma Kemahiran Malaysia", value: "diploma_kemahiran_malaysia" },
            { label: "Sijil Kemahiran Malaysia", value: "sijil_kemahiran_malaysia" },
            { label: "STPM", value: "stpm" },
            { label: "SPM", value: "spm" },
            { label: "PMR / PT3", value: "pmr_pt3" },
            { label: "UPSR", value: "upsr" },
            { label: "Did not attend formal education", value: "no_formal_education" }
          ]
        },
        { type: "subheading", label: " Driving License" },
        {
          name: "driving_license",
          // label: "Driving License",
          type: "radio",
          labelAbove: true,
          options: [
            { label: "Did not posses any", value: "none" },
            { label: "D, DA (Motorcar below 3500 kg)", value: "d_da" },
            {
              label: "B, B1, B2 (Motocycle 500 cc, below 500 cc, below 250 cc)",
              value: "b_b1_b2"
            },
            {
              label: "A, A1 (Invalid Carriage Motocycle, Motorcar)",
              value: "a_a1"
            },
            {
              label: "E, F, G, H, I (Heavy Motorcar, Tractor, Machinery)",
              value: "e_f_g_h_i"
            },
            {
              label: "PSV, GDL (Vocational Driving License)",
              value: "psv_gdl"
            }
          ]
        },
{ type: "subheading", label: "Client's Vocational Interests" },
        {
          name: "client_interest",
          // label: "Client Interest",
          type: "checkbox-group",
          options: [
            { label: "Sewing", value: "sewing" },
            { label: "Bakery", value: "bakery" },
            { label: "Urban farming", value: "urban_farming" },
            { label: "Design", value: "design" },
            { label: "Hands On", value: "hands_on" },
            { label: "Electrical", value: "electrical" },
            { label: "Electronics", value: "electronics" },
            { label: "Office Administration", value: "office_admin" },
            { label: "Short Course", value: "short_course" },
            { label: "Entrepreneurship", value: "entrepreneurship" },
            { label: "Barista", value: "barista" },
            { label: "Hairstyling", value: "hairstyling" },
            { label: "Culinary", value: "culinary" },
            { label: "Automotive", value: "automotive" },
            { label: "Innovart", value: "innovart" },
            { label: "Florist", value: "florist" },
            {label:"Not Sure / Undecided",value:'undecided'}
          ]
        },
         {
          name: "client_self_reported_goals_preferences",
          label: "Client's Self-Reported Goals / Preferences",
          type: "input",
          placeholder: "Enter the client's self-reported goals and preferences"
        },

        // {
        //   name: "environment_limitation",
        //   label: "Environment and Limitation",
        //   type: "checkbox-group",
        //   options: [
        //     { label: "Standing", value: "standing" },
        //     { label: "Walking", value: "walking" },
        //     { label: "Sitting", value: "sitting" },
        //     { label: "Stretching", value: "stretching" },
        //     { label: "Squatting or Crouching", value: "squatting_crouching" },
        //     { label: "Twisting body or neck", value: "twisting_body_neck" },
        //     {
        //       label: "Lifting and carrying weight",
        //       value: "lifting_carrying_weight"
        //     },
        //     { label: "Repetitive movement", value: "repetitive_movement" },
        //     { label: "Driving", value: "driving" },
        //     { label: "Using hand equipment", value: "using_hand_equipment" },
        //     { label: "Stooping", value: "stooping" },
        //     {
        //       label: "Memory of concentration activity",
        //       value: "memory_concentration"
        //     },
        //     { label: "Visual Impaired", value: "visual_impaired" },
        //     { label: "Hearing Impaired", value: "hearing_impaired" },
        //     { label: "Speech Impaired", value: "speech_impaired" }
        //   ]
        // }
      ]
    }
  ]
};


const CONSENT_AND_REFERRAL_SCHEMA = {
  title: "",
  sections: [
    {
      fields: [
        {
          type: "row",
          fields: [
            {
              name: "consent_obtained",
              type: "checkbox-group",
              options: [{ label: "Consent obtained", value: "yes" }]
            },
            {
              name: "consent_upload",
              label: "Upload",
              type: "file-upload",
              showIf: { field: "consent_obtained", includes: "yes" }
            }
          ]
        },
        {
          name: "hep_reviewed",
          type: "checkbox-group",
          options: [{ label: "Home Exercise Program (HEP) reviewed and demonstrated", value: "yes" }]
        },
        {
          name: "current_diagnosis",
          label: "Current Diagnosis",
          type: "multi-select-dropdown",
          options: [
            { label: "Stroke", value: "stroke" },
            { label: "Traumatic Brain Injury", value: "tbi" },
            { label: "Parkinson Disease", value: "parkinson" },
            { label: "Spinal Cord Injury", value: "sci" },
            { label: "Peripheral Neuropathy", value: "peripheral_neuropathy" },
            { label: "Ligament injuries", value: "ligament_injuries" },
            { label: "Ataxia", value: "ataxia" },
            { label: "Others", value: "others" }
          ]
        },
        {
          name: "current_diagnosis_other",
          label: "Other Diagnosis (specify)",
          type: "input",
          showIf: { field: "current_diagnosis", includes: "others" }
        },
        {
          name: "equipment_owned",
          label: "List of Equipment Owned",
          type: "checkbox-group",
          options: [
            { label: "PERKESO", value: "perkeso" },
            { label: "NGO", value: "ngo" },
            { label: "Self-purchased", value: "self" },
            { label: "Others", value: "others" }
          ]
        },
        {
          name: "equipment_perkeso",
          label: "PERKESO Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "perkeso" }
        },
        {
          name: "equipment_ngo",
          label: "NGO Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "ngo" }
        },
        {
          name: "equipment_self",
          label: "Self-purchased Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "self" }
        },
        {
          name: "equipment_others",
          label: "Other Equipment Details",
          type: "input",
          showIf: { field: "equipment_owned", includes: "others" }
        }
        ,
        { type: "subheading", label: "Referral Information" },
        {
          name: "referred_by",
          label: "Referred by",
          type: "input",
          readOnly: true
        },
        {
          name: "referral_reasons",
          label: "Referral Reasons",
          type: "input",
          readOnly: true
        }
      ]
    }
  ]
};

  const VOCATIONAL_CONTAINER_SCHEMA = {
    title: "Patient Information",
    sections: []
  };

 const OBJECTIVE_SCHEMA = {
  title: "",
 actions: [
      { type: "back", label: "Back" },
      { type: "clear", label: "Clear" },
      { type: "save", label: "Save" }
    ],
  sections: [
    {
      fields: [
//         { type: "subheading", label: "Environmental & Physical Functional Limitations" },
//  {
//           name: "functional_limitations",
//           // label: "Functional Limitations",
//           type: "checkbox-group",
//           options: [
//             { label: "Standing", value: "standing" },
//             { label: "Walking", value: "walking" },
//             { label: "Sitting", value: "sitting" },
//             { label: "Stretching", value: "stretching" },
//             { label: "Squatting or Crouching", value: "squatting_or_crouching" },
//             { label: "Twisting Body or Neck", value: "twisting_body_or_neck" },
//             { label: "Lifting and Carrying Weight", value: "lifting_and_carrying_weight" },
//             { label: "Repetitive Movement", value: "repetitive_movement" },
//             { label: "Driving", value: "driving" },
//             { label: "Using Hand Equipment", value: "using_hand_equipment" },
//             { label: "Stooping", value: "stooping" },
//             { label: "Memory / Concentration Activity", value: "memory_concentration_activity" },
//             { label: "Visual Impairment", value: "visual_impairment" },
//             { label: "Hearing Impairment", value: "hearing_impairment" },
//             { label: "Speech Impairment", value: "speech_impairment" }
//           ]
//         },
//         {
//           name: "therapist_objective_observations",
//           label: "Therapist's Objective Observations on Occupational Performance",
//           type: "input",
//           placeholder: "Enter therapist's objective observations on occupational performance"
//         },
        // {
        //   name: "vocational_scales",
        //   type: "assessment-launcher",
        //   options: [
        //     { label: "Berg Balance Scale (BBS)",              value: "BergBalanceScale"       },

        //     { label: "Montreal Cognitive Assessment (MoCA)", value: "MoCAAssessment" },
        //      { label: "BECKER WORK ADJUSTMENT PROFILE", value: "BeckerWorkAdjustmentProfile" },
        //      {label:'BTS PRIMUS',value:'BTEAssessment '}

        //   ]
        // },
        {
  name: "vocational_scales",
  type: "assessment-launcher",
  options: [
    {
      label: "Berg Balance Scale (BBS)",
      value: "BergBalanceScale"
    },
    {
      label: "Montreal Cognitive Assessment (MoCA)",
      value: "MoCAAssessment"
    },
    {
      label: "BECKER WORK ADJUSTMENT PROFILE",
      value: "BeckerWorkAdjustmentProfile"
    },
    {
      label: "BTE PRIMUS RS",
      value: "BTEAssessment"
    }
  ]
}
      ]
    }
  ]
}

const SCORE_OPTIONS = ["0", "1", "2", "3", "4"];

const ASSESSMENT_SCHEMA = {
  title: "",
  actions: [
    { type: "back", label: "Back" },
    { type: "clear", label: "Clear" },
    { type: "save", label: "Save" }
  ],

  sections: [
    {
      fields: [
        {
          type: "subheading",
          label: "Physical, Cognitive and Sensory Demand"
        },

      
{
  type: "accordion",
  name: "physical_demand_section",
  label: "Physical Demand",
  defaultOpen: false,
  children: [
    {
      type: "grid-table-flat",
      name: "physical_demand",
      headers: ["Observation", "Score", "Remarks"],
      headerOptions: {
        Score: SCORE_OPTIONS
      },
      rows: [
        { key: "sitting_tolerance", label: "Sitting Tolerance" },
        { key: "standing_tolerance", label: "Standing Tolerance" },
        { key: "walking_mobility", label: "Walking & Mobility" },
        { key: "upper_limb_function", label: "Upper Limb Function" },
        { key: "hand_function", label: "Hand Function" },
        { key: "bilateral_coordination", label: "Bilateral Coordination" },
        { key: "strength_endurance", label: "Strength & Endurance" },
        { key: "fine_motor_skills", label: "Fine Motor Skills" },
        { key: "gross_motor_skills", label: "Gross Motor Skills" },
        { key: "safety_awareness", label: "Safety Awareness" }
      ]
    }
  ]
},



        {
  type: "accordion",
  name: "cognitive_demand_section",
  label: "Cognitive Demand",
  defaultOpen: false,
  children: [
    {
      type: "grid-table-flat",
      name: "cognitive_demand",
      headers: ["Observation", "Score", "Remarks"],
      headerOptions: {
        Score: SCORE_OPTIONS
      },
      rows: [
        { key: "attention", label: "Attention & Concentration" },
        { key: "understanding", label: "Understanding Instructions" },
        { key: "memory", label: "Memory" },
        { key: "problem_solving", label: "Problem Solving" },
        { key: "sequencing", label: "Sequencing" },
        { key: "learning_ability", label: "Learning Ability" },
        { key: "decision_making", label: "Decision Making" },
        { key: "time_awareness", label: "Time Awareness" },
        { key: "task_completion", label: "Task Completion" },
        { key: "adaptability", label: "Adaptability" }
      ]
    }
  ]
},

    

        {
  type: "accordion",
  name: "sensory_demand_section",
  label: "Sensory & Perceptual Demand",
  defaultOpen: false,
  children: [
    {
      type: "grid-table-flat",
      name: "sensory_demand",
      headers: ["Observation", "Score", "Remarks"],
      headerOptions: {
        Score: SCORE_OPTIONS
      },
      rows: [
        { key: "vision", label: "Vision" },
        { key: "hearing", label: "Hearing" },
        { key: "communication", label: "Communication" },
        { key: "tactile_function", label: "Tactile Function" },
        { key: "visual_motor", label: "Visual-Motor Coordination" },
        { key: "spatial_awareness", label: "Spatial Awareness" },
        { key: "sensory_tolerance", label: "Sensory Tolerance" },
        { key: "environmental_awareness", label: "Environmental Awareness" }
      ]
    }
  ]
},

       

 {
  type: "accordion",
  name: "rating_scale_section",
  label: "Rating Scale",
  defaultOpen: false,
  children: [
    {
      name: "functional_rating_scale",
      label: "Rating Scale",
      type: "scale-slider",
      min: 0,
      max: 4,
      ranges: [
        {
          min: 0,
          max: 0,
          label: "Unable / Full Assistance",
          color: "#ef4444"
        },
        {
          min: 1,
          max: 1,
          label: "Significant Difficulty",
          color: "#f97316"
        },
        {
          min: 2,
          max: 2,
          label: "Moderate Difficulty",
          color: "#facc15"
        },
        {
          min: 3,
          max: 3,
          label: "Mild Difficulty",
          color: "#84cc16"
        },
        {
          min: 4,
          max: 4,
          label: "Independent / Functional",
          color: "#22c55e"
        }
      ],
      showValue: true
    }
  ]
}

   
      ],
      
    }
  ]
};

const PLAN_SCHEMA = {
  title: "",

  sections: [
    {
      fields: [

     { type: "subheading", label: "Short Term Goals (2–4 Weeks)" },
        { type: "dynamic-goals", name: "short_term_goals" },
        
        { type: "subheading", label: "Long Term Goals (6–12 Weeks)" },
        { type: "dynamic-goals", name: "long_term_goals" },
        
        
 {
          name: "plan_therapist_remarks",
          label: "Plan / Therapist Remarks",
          type: "input",
          placeholder: "Enter plan and therapist remarks"
        },
        {
          name: "suggestions_recommendations",
          label: "Suggestions & Recommendations",
          type: "input",
          placeholder: "Enter suggestions and recommendations"
        },
         {
          name: "module_referral",
          label: "Module Referral",
          type: "checkbox-group",
          options: [
       
            {
              label: "Discharge from Vocational Programme (client not interested / not required)",
              value: "discharge_from_vocational_programme"
            },
            {
              label: "Refer to Trainer (see reference list below)",
              value: "refer_to_trainer"
            },
            {
              label: "Refer to Module (see reference list below)",
              value: "refer_to_module"
            }
          ]
        },
        {
          name: "referred_trainer",
          label: "Referred Trainer",
          type: "select",
          placeholder: "Select from Trainer List",
          options: TRAINER_OPTIONS,
          showIf: {
            field: "module_referral",
            includes: "refer_to_trainer"
          }
        },
        {
          name: "referred_module_functional",
          label: "Referred Module",
          type: "multi-select-dropdown",
          placeholder: "Select from Module List",
          options: MODULE_OPTIONS,
          showIf: {
            field: "module_referral",
            includes: "refer_to_module"
          }
        },
      ]
    }
  ]
};


  const TREATMENT_PLAN_LABEL_MAP = {
    bed_mobility: "Bed mobility training",
    transfer: "Transfer training",
    MTM: "Muscle tone management",
    SBT: "Sitting balance training",
    StBT: "Standing balance training",
    FRE: "Functional ROM Exercise",
    strength: "Functional strengthening exercise",
    endurance: "Endurance training",
    FT: "Functional training",
    gait: "Gait training",
    WAP: "Walking aid prescription",
    bobath: "Bobath / NDT",
    others: "Others"
  };

  /* ===================== UI ===================== */
  const schemaMap = {
    subjective: SUBJECTIVE_SCHEMA,
    objective: OBJECTIVE_SCHEMA,
    assessment: ASSESSMENT_SCHEMA,
    plan: PLAN_SCHEMA
  };

  const tabOrder = ["subjective", "objective", "assessment", "plan"];

  // function VocationalRehabPatientInfo({ patient, patientHistory, setPatientHistory }) {
  //   if (!patient) return null;

  //   return (
  //     <div style={section}>
  //       <div style={patientGrid}>
  //         <div><b>Name:</b> {patient.name}</div>
  //         <div><b>IC:</b> {patient.id}</div>
  //         <div><b>DOB:</b> {formatDate(patient.dob)}</div>
  //         <div><b>Age / Gender:</b> {patient.age} / {patient.sex}</div>
  //         <div><b>ICD:</b> {patient.icd}</div>
  //         <div><b>Date of Assessment:</b> {today.toLocaleDateString()}</div>
  //         <div><b>Date of Onset:</b> {formatDate(patient.date_of_onset)}</div>
  //         <div><b>Duration of Diagnosis:</b> {calculateDuration(patient.date_of_onset)}</div>
  //         <div><b>Primary Diagnosis:</b> {patient.diagnosis_history || "-"}</div>
  //         <div><b>Secondary Diagnosis:</b> {patient.medical_history || "-"}</div>
  //         <div><b>Dominant Side:</b> {patient.dominant_side || "-"}</div>
  //         <div><b>Language Preference:</b> {patient.language_preference || "-"}</div>
  //         <div><b>Education Level:</b> {patient.education_background || "-"}</div>
  //         <div><b>Occupation:</b> {patient.occupation || "-"}</div>
  //         <div><b>Work Status:</b> {patient.employment_status || "-"}</div>
  //         <div><b>Driving Status:</b> {patient.driving_status || "-"}</div>
  //         <div><b>Marital Status:</b> {patient.marital_status || patient.marital || "-"}</div>

  //         <div style={{ gridColumn: "1 / -1", marginTop: 8 }}>
  //           <div style={{ fontWeight: 800, marginBottom: 8 }}>Patient History</div>
  //           <div style={{ marginBottom: 10 }}>
  //             <div style={{ fontWeight: 600, marginBottom: 6 }}>Past Medical History</div>
  //             <input
  //               value={patientHistory.past_medical_history}
  //               onChange={(e) => setPatientHistory((prev) => ({ ...prev, past_medical_history: e.target.value }))}
  //               style={{
  //                 width: "100%",
  //                 minHeight: 90,
  //                 padding: "10px 12px",
  //                 borderRadius: 6,
  //                 border: "1px solid #d1d5db",
  //                 fontSize: 14,
  //                 fontFamily: "inherit",
  //                 resize: "vertical",
  //               }}
  //             />
  //           </div>

  //           <div style={{ marginBottom: 10 }}>
  //             <div style={{ fontWeight: 600, marginBottom: 6 }}>Family History</div>
  //             <input
  //               value={patientHistory.past_family_history}
  //               onChange={(e) => setPatientHistory((prev) => ({ ...prev, past_family_history: e.target.value }))}
  //               style={{
  //                 width: "100%",
  //                 minHeight: 90,
  //                 padding: "10px 12px",
  //                 borderRadius: 6,
  //                 border: "1px solid #d1d5db",
  //                 fontSize: 14,
  //                 fontFamily: "inherit",
  //                 resize: "vertical",
  //               }}
  //             />
  //           </div>
  //           <div style={{ marginBottom: 10 }}>
  //             <div style={{ fontWeight: 600, marginBottom: 6 }}>Allergies</div>
  //             <input
  //               value={patientHistory.alerts_and_allergies}
  //               onChange={(e) => setPatientHistory((prev) => ({ ...prev, alerts_and_allergies: e.target.value }))}
  //               style={{
  //                 width: "100%",
  //                 minHeight: 90,
  //                 padding: "10px 12px",
  //                 borderRadius: 6,
  //                 border: "1px solid #d1d5db",
  //                 fontSize: 14,
  //                 fontFamily: "inherit",
  //                 resize: "vertical",
  //               }}
  //             />
  //           </div> 
  //           <div style={{ marginBottom: 10 }}>
  //             <button
  //               type="button"
  //               onClick={() => {
  //                 console.log("Alerts button clicked!");
  //               }}
  //               style={{
  //                 marginTop: "10px",
  //                 padding: "10px 20px",
  //                 borderRadius: 6,
  //                 border: "1.5px solid rgb(0, 123, 255)",
  //                 background: "rgb(0, 123, 255)",
  //                 color: "rgb(255, 255, 255)",
  //                 fontWeight: 600,
  //                 fontSize: 14,
  //                 cursor: "pointer",
  //                 display: "inline-flex",
  //                 alignItems: "center",
  //                 gap: 6,
  //                 boxShadow: "0 1px 2px rgba(0,0,0,0.06)"
  //               }}
  //             >
  //               🚨 Alerts
  //             </button>
  //           </div>           
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
          function PatientInformationBlock({ patient, patientHistory, setPatientHistory }) {
  if (!patient) return null;

  const safe = (v) => v ?? "-";
  const formatDate = (d) => d ? new Date(d).toLocaleDateString() : "-";

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: 12,
        fontSize: 14
      }}>
        <div><b>Name:</b> {safe(patient.name)}</div>
        <div><b>IC:</b> {safe(patient.id)}</div>
        <div><b>DOB:</b> {formatDate(patient.dob)}</div>

        <div><b>Age / Gender:</b> {safe(patient.age)} / {safe(patient.sex)}</div>
        <div><b>ICD:</b> {safe(patient.icd)}</div>
        <div><b>Date of Assessment:</b> {new Date().toLocaleDateString()}</div>

        <div><b>Date of Onset:</b> {formatDate(patient.date_of_onset)}</div>
        <div><b>Duration of Diagnosis:</b> -</div>
        <div><b>Primary Diagnosis:</b> {safe(patient.diagnosis_history)}</div>

        <div><b>Secondary Diagnosis:</b> {safe(patient.medical_history)}</div>
        <div><b>Dominant Side:</b> {safe(patient.dominant_side)}</div>
        <div><b>Language Preference:</b> {safe(patient.language_preference)}</div>

        <div><b>Education Level:</b> {safe(patient.education_background)}</div>
        <div><b>Occupation:</b> {safe(patient.occupation)}</div>
        <div><b>Work Status:</b> {safe(patient.employment_status)}</div>

        <div><b>Driving Status:</b> {safe(patient.driving_status)}</div>
        <div><b>PP/OB:</b> {safe(patient.pp_ob)}</div>
        <div><b>Weight:</b> {patient.weight ? `${patient.weight} kg` : "-"}</div>

        {/* ===== HISTORY ===== */}
        <div style={{ gridColumn: "1 / -1", marginTop: 10 }}>
        
           <h3>Patient History</h3>
        
                  <div>
                    <b>Past Medical History</b>
                    <input
                      style={input}
                      value={patientHistory.past_medical_history}
                      onChange={(e) =>
                        setPatientHistory(prev => ({
                          ...prev,
                          past_medical_history: e.target.value
                        }))
                      }
                    />
                  </div>

          
          <div>
                    <b>Family History</b>
                    <input
                      style={input}
                      value={patientHistory.past_family_history}
                      onChange={(e) =>
                        setPatientHistory(prev => ({
                          ...prev,
                          past_family_history: e.target.value
                        }))
                      }
                    />
                  </div>

        
           <div>
                    <b>Allergies</b>
                    <input
                      style={input}
                      value={patientHistory.alerts_and_allergies}
                      onChange={(e) =>
                        setPatientHistory(prev => ({
                          ...prev,
                          alerts_and_allergies: e.target.value
                        }))
                      }
                    />
                  </div>

          <button style={alertBtn}>🚨 Alerts</button>
        </div>
      </div>
    </div>
  );
}
  return (
    <div style={mainContent}>

      {/* ===== PATIENT INFORMATION CARD ===== */}
 
         <PatientCard
                  patient={patient}
                 
                />
              

      {/* ===== NEW ENVIRONMENT CARD ===== */}
   <CommonFormBuilder
      schema={CONSENT_AND_REFERRAL_SCHEMA}
      values={values}
      onChange={onChange}
    />

      {/* ===== TABS ===== */}
      <div style={tabBar}>
        {["subjective", "objective", "assessment", "plan"].map(tab => (
          <div
            key={tab}
            style={activeTab === tab ? tabActive : tabBtn}
            onClick={() => setActiveTab(tab)}
          >
            {tab.toUpperCase()}
          </div>
        ))}
      </div>

      {/* ===== TAB CONTENT ===== */}
      <CommonFormBuilder
        schema={schemaMap[activeTab]}
        values={values}
        onChange={onChange}
        submitted={submitted}
        onAction={handleAction}
        assessmentRegistry={VOCATIONAL_REHAB_REGISTRY}
        
      >
        <div style={submitRow}>
          {activeTab !== "plan" ? (
            <button
              type="button"
              style={submitBtn}
              onClick={() => {
                if (activeTab === "subjective") setActiveTab("objective");
                else if (activeTab === "objective") setActiveTab("assessment");
                else if (activeTab === "assessment") setActiveTab("plan");
              }}
            >
              Next
            </button>
          ) : (
            <button
              type="button"
              style={submitBtn}
              onClick={handleSubmit}
            >
              Submit
            </button>
          )}
        </div>
      </CommonFormBuilder>
    </div>
  );
}

/* ===================== STYLES ===================== */

const mainContent = { margin: "0 auto" };

const section = {
  marginBottom: 24
};

const patientGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 12,
  fontSize: 14
};

const tabBar = {
  display: "flex",
  gap: 12,
  justifyContent: "center",
  borderBottom: "1px solid #ddd",
  marginBottom: 12
};

const tabBtn = {
  padding: "10px 22px",
  fontWeight: 600,
  cursor: "pointer",
  color: "#0f172a"
};

const tabActive = {
  ...tabBtn,
  borderBottom: "3px solid #2451b3",
  color: "#2451b3"
};

const submitRow = {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: 20
};

const submitBtn = {
  padding: "12px 32px",
  background: "#2563EB",
  color: "#fff",
  border: "none",
  borderRadius: 10,
  fontSize: 15,
  fontWeight: 700
};
const th = {
  border: "1px solid #ccc",
  padding: 10,
  textAlign: "left"
};

const td = {
  border: "1px solid #ccc",
  padding: 10
};
const input = {
          width: "100%",
          minHeight: 90,
          marginTop: 6,
          marginBottom: 12,
          padding: "10px 12px",
          borderRadius: 6,
          border: "1px solid #d1d5db",
          fontSize: 14,
          resize: "vertical"
};
const alertBtn = {
  marginTop: 10,
          padding: "10px 20px",
          borderRadius: 6,
          border: "1.5px solid #007bff",
          background: "#007bff",
          color: "#fff",
          fontWeight: 600,
          cursor: "pointer"
};
const doctorsReportBtn = {
  padding: "10px 20px", background: "#2563EB", color: "#fff",
  border: "none", borderRadius: 6, fontSize: 14,
  fontWeight: 600, cursor: "pointer", marginTop: 8
};